import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import Flex from '../../atoms/Flex';
import { color } from '../../templates/Ui';
const StyledTabItem = styled(({ ...props }) => _jsx("button", { ...props })) `
    transition: background-color 0.2s ease-in-out;
    position: relative;
    padding: 12px;
    margin-right: 15px;
    text-decoration: none;
    border: 1px solid #ececec;
    border-radius: 6px;
    background-color: ${props => props.isActive ? color.gray.light : 'transparent'};
    z-index: 1;

    ${props => !props.isActive &&
    css `
            &:hover,
            &:focus {
                background-color: ${color.gray.lightest};
                h4 {
                    color: ${props => props.theme.primary.base};
                }

                svg {
                    fill: ${props => props.theme.secondary};
                }
            }
        `}
`;
const Icon = styled.div `
    display: inline-flex;
    margin-right: 8px;

    svg {
        transition: fill 0.2s ease-in-out;
        fill: ${props => props.isActive ? props.theme.secondary : color.paragraph.base};
    }
`;
const Title = styled.h4 `
    transition: color 0.2s ease-in-out;
    font-size: 14px;
    line-height: 15px;
    font-weight: ${props => (props.isActive ? '700' : '400')};
    color: ${props => props.isActive ? props.theme.primary : color.paragraph.base};
    white-space: nowrap;

    @media only screen and (min-width: 768px) {
        font-size: 16px;
    }
`;
const TabItem = ({ icon, title, isActive, ...resProps }) => (_jsx(StyledTabItem, { isActive: isActive, ...resProps, children: _jsxs(Flex, { alignItems: "center", children: [_jsx(Icon, { isActive: isActive, children: icon }), _jsx(Title, { isActive: isActive, children: title })] }) }));
export default TabItem;
